import { z } from 'zod';

const PERSON_NAME_MAX_LENGTH = 50;

function createFirstNameSchema(t: (key: string) => string) {
  return z.string().min(1, t('validation.firstName.required')).min(2, t('validation.firstName.minLength')).max(PERSON_NAME_MAX_LENGTH, t('validation.firstName.maxLength'));
}

function createLastNameSchema(t: (key: string) => string) {
  return z.string().min(1, t('validation.lastName.required')).min(2, t('validation.lastName.minLength')).max(PERSON_NAME_MAX_LENGTH, t('validation.lastName.maxLength'));
}

export { createFirstNameSchema, createLastNameSchema, PERSON_NAME_MAX_LENGTH };
